import importer from '@shared/library/dist/methods/importer';
import axios, { AxiosError } from 'axios';
import React, { useCallback, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import formDataValidator from '../../../../helpers/formData';
import { languages } from '../../../../language';
import { config } from '../../../../static/config';
import '../Login/LogIn.scss';
//#region COMPONENTS
import Alert from '@mui/material/Alert';
import CustomButton from '../../../gest/CustomButton/CustomButton';
import CustomInput from '../../../gest/CustomInput/CustomInput';
//#endregion
//ICONS
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import { ReactComponent as LogoDark } from '../../../../assets/images/logo_dark.svg';
//CONTEXTS
import { GestCard } from '@shared/library';
import { CntxConfig } from '../../../Optisewer';

const ForgotPassword = () => {
    //CONTEXTS USE
    const cntxConfig = useContext(CntxConfig);

    //STATIC DATA
    const navigate = useNavigate();
    const lang = languages(cntxConfig?.settings?.lang);

    //#region STATES
    const [sendAgainTimer, setSendAgainTimer] = React.useState(61);
    const username = React.useRef("");
    //FLAGS
    const [errorAnimation, setErrorAnimation] = React.useState(false);
    const [submitOK, setSubmitOK] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    //#endregion

    //#region METHODS

    //#region API CALLS
    const requirePasswordChangeOTP = (e?: any) => {
        if (e) {
            e.preventDefault();
            username.current = (formDataValidator(e.target, 'object') as { username: string; }).username;
        }

        if (username.current) {
            setLoading(true);
            axios.get(`${config.api.internal}/Auth/${username.current}/OTP/Password/Require`)
                .then(() => setSubmitOK(true))
                .catch((err: AxiosError) => {
                    animateError();
                    username.current = "";
                })
                .finally(() => setLoading(false));
        }
        else {
            animateError();
        }
    };

    const sendAgain = useCallback(() => {
        if (submitOK && username.current) {
            requirePasswordChangeOTP();
        }
    }, [submitOK, username.current]);
    //#endregion

    const animateError = () => {
        setErrorAnimation(true);
        setTimeout(() => {
            setErrorAnimation(false);
        }, 100);
    };
    //#endregion

    //STATES CHANGE
    React.useEffect(() => {
        if (submitOK && sendAgainTimer > 0) {
            setTimeout(() => {
                setSendAgainTimer(sendAgainTimer - 1);
            }, 1000);
        }
    }, [submitOK, sendAgainTimer]);

    return (
        <GestCard type="floating" id="Login" style={{ width: '350px' }}>
            <div className="logo">
                <LogoDark className={`mb-3 ${errorAnimation ? 'shake' : ''} `} />
                {/* <img className={`mb-3 ${errorAnimation ? 'shake' : ''} `} src={importer1.img.require('logo_dark', 'svg')} alt="" /> */}
                <h4 className='mb-0'>{lang.reset_password}</h4>
            </div>

            <div className='my-4'>
                {submitOK
                    ?
                    <>
                        <Alert icon={false}>
                            <p className='m-0 mb-1 text-justify'>{lang.password_request_completed}</p>

                            <p className='m-0 text-justify'>{lang.check_your_inbox}</p>

                            <div className='mt-2 w-100 justify-content-center'><EmailRoundedIcon fontSize='large' /></div>

                            <span className='d-flex text-xs'>
                                {lang.didnt_receive_email}
                                &nbsp;
                                {
                                    <a
                                        onClick={() => {
                                            if (!sendAgainTimer) {
                                                sendAgain();
                                                setSendAgainTimer(61);
                                            }
                                        }}

                                        className={sendAgainTimer ? 'text-disabled' : ''}
                                    >
                                        {lang.send_again}
                                    </a>
                                }
                                &nbsp;
                                {sendAgainTimer ? `(${sendAgainTimer})` : ''}
                            </span>
                        </Alert>

                        <a className='mt-2' onClick={() => { navigate('/login'); }}><strong>{lang.back_to_login}</strong></a>
                    </>
                    :
                    <form onSubmit={requirePasswordChangeOTP}>
                        <fieldset>
                            <CustomInput
                                name="username"
                                variant="cloud"
                                img={importer.ic.require('user', 'svg')}
                                placeholder={lang.username}
                                class="mb-2"
                            />
                        </fieldset>

                        <div>
                            <CustomButton variant="primary" type={"submit"} class="w-100 mb-2">{lang.reset}</CustomButton>
                            <a className='' onClick={() => { navigate('/login'); }}><strong>{lang.back_to_login}</strong></a>
                        </div>
                    </form>
                }
            </div>
        </GestCard>
    );
};
export default React.memo(ForgotPassword);


// http://localhost:3001/